import React from 'react';
import { Flame, CheckCircle2 } from 'lucide-react';
export function TopBar() {
  return <div className="sticky top-0 z-50 w-full" data-id="element-228">
      {/* Urgency Bar */}
      <div className="bg-brand-teal text-white px-4 py-3 text-center shadow-md" data-id="element-229">
        <p className="text-sm md:text-base font-medium flex items-center justify-center gap-2 flex-wrap" data-id="element-230">
          <Flame className="w-5 h-5 text-brand-gold animate-pulse" data-id="element-231" />
          <span className="font-bold text-brand-gold" data-id="element-232">
            OFERTA DE LANZAMIENTO:
          </span>
          15 cupos restantes con el 65% de descuento antes de que el precio suba
          a $29.900 ARS.
        </p>
      </div>

      {/* Trust Badges */}
      <div className="bg-white border-b border-gray-100 py-2 hidden md:block" data-id="element-233">
        <div className="max-w-7xl mx-auto px-4 flex justify-center items-center gap-8 text-xs text-gray-600 font-medium" data-id="element-234">
          <div className="flex items-center gap-1.5" data-id="element-235">
            <CheckCircle2 className="w-4 h-4 text-brand-teal" data-id="element-236" />
            <span data-id="element-237">Método Basado en Nutrición Funcional</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-238">
            <CheckCircle2 className="w-4 h-4 text-brand-teal" data-id="element-239" />
            <span data-id="element-240">Protocolo Dr. Ludwig Johnson</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-241">
            <CheckCircle2 className="w-4 h-4 text-brand-teal" data-id="element-242" />
            <span data-id="element-243">100% Ingredientes de Latinoamérica</span>
          </div>
        </div>
      </div>
    </div>;
}